// extracted by mini-css-extract-plugin
export default {"collection":"MyCollectionButton-module__collection","border":"MyCollectionButton-module__border","icon":"MyCollectionButton-module__icon"};